import { createI18n } from "vue-i18n";

import CookieService from "@/common/cookie.service";
import da_DK from "@/i18n/locales/da_DK.json";

enum Locale {
  DA_DK = "da_DK"
}
const DEFAULT_LOCALE = Locale.DA_DK;

const isValidLocale = (locale: string | undefined): locale is Locale =>
  Object.values(Locale).includes(locale as Locale);

export const getLocale = (): Locale => {
  const storedLocale = CookieService.get("locale");

  if (isValidLocale(storedLocale)) {
    return storedLocale;
  }

  return DEFAULT_LOCALE;
};

// Set da_DK as the master schema for i18n and init
type MessageSchema = typeof da_DK;
export const i18n = createI18n<[MessageSchema], "da_DK">({
  locale: "da_DK", // set locale,
  messages: { da_DK }
});

export const setLocale = (locale: Locale): void => {
  CookieService.set("locale", locale);
  document.querySelector("html")?.setAttribute("lang", locale.substring(0, 2));
};

export const init = () => {
  const storedOrDefaultLocale = getLocale();
  setLocale(storedOrDefaultLocale);
};
